var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "item",
      class: _vm.result.Status.toLowerCase(),
      attrs: { tabindex: "0" }
    },
    [
      _c("span", { staticClass: "name list-item-info hide-desktop" }, [
        _vm._v(_vm._s(_vm.result.FirstName) + " " + _vm._s(_vm.result.LastName))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "name-first list-item-info hide-mobile" }, [
        _vm._v(_vm._s(_vm.result.FirstName))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "name-last list-item-info hide-mobile" }, [
        _vm._v(_vm._s(_vm.result.LastName))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "email list-item-info" }, [
        _c(
          "a",
          {
            attrs: {
              href: "mailto:" + _vm.result.Email,
              title: "Email " + _vm.result.FirstName + _vm.result.LastName
            }
          },
          [_vm._v(_vm._s(_vm.result.Email))]
        )
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "dba list-item-info" }, [
        _vm._v(_vm._s(_vm.result.Status))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "user-actions list-item-info" }, [
        _vm.result.Status !== "Disabled"
          ? _c("div", { staticClass: "current-user" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "/account/edit/" + _vm.result.ContactGuid,
                    title: "Edit User"
                  }
                },
                [
                  _c("span", {
                    staticClass: "icon icon-edit user-action edit-user"
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "icon icon-block user-action remove-user",
                attrs: { tabindex: "0", title: "Remove User" },
                on: {
                  click: function($event) {
                    return _vm.deleteUser()
                  },
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.deleteUser()
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.result.Status === "Disabled"
          ? _c("div", { staticClass: "new-user" }, [
              _c(
                "a",
                {
                  attrs: {
                    href: "/account/add/kentico-user/" + _vm.result.ContactGuid,
                    title: "Add User"
                  }
                },
                [
                  _c("span", {
                    staticClass: "icon icon-user-plus user-action add-user"
                  })
                ]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-256bd0a1", { render: render, staticRenderFns: staticRenderFns })
  }
}